exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-aside{overflow:auto;box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib!./~/element-ui/lib/theme-chalk/aside.css
// module id = 178
// module chunks = 0